import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hamburger", "close"]
  static values = { target: String }
  connect() {
  }

  toggle() {
    const targetElement = document.getElementById(this.targetValue)
    const currentlyExpanded = targetElement.getAttribute("aria-expanded") === "true"
    if (currentlyExpanded) {
      targetElement.setAttribute("aria-expanded", "false")
      this.hamburgerTarget.classList.remove("hidden")
      this.closeTarget.classList.add("hidden")
    } else {
      targetElement.setAttribute("aria-expanded", "true")
      this.hamburgerTarget.classList.add("hidden")
      this.closeTarget.classList.remove("hidden")
    }
  }
}
